// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import CountingBundleEarlierOrder from './countingBundleEarlierOrder';
import React from 'react';

function CountingBundleEarlierOrderPage () {

    return (
        <AuthenticatedPage className="atp-page atp-counting-bundle-earlier-order-page">
            <CountingBundleEarlierOrder />
        </AuthenticatedPage>
    );

}
CountingBundleEarlierOrderPage.displayNAme = 'CountingBundleEarlierOrderPage';

export default CountingBundleEarlierOrderPage;
